/**
 * 將 external resolve API 回傳正規化為 Activity 地點 node。
 * 只保留 locationId／展示欄位；禁止把 providerPlaceId 寫入 Activity。
 */
export function toActivityLocationNode(resolved) {
  if (!resolved?.locationId) return null;
  return {
    locationId: resolved.locationId,
    displayName: resolved.displayName || resolved.canonicalName || '已選地點',
    latitude: resolved.latitude ?? null,
    longitude: resolved.longitude ?? null,
    address: resolved.address ?? null,
  };
}

/**
 * 呼叫 resolve 並回傳 Activity location node（不含 providerPlaceId）。
 */
export async function resolveExternalPlaceToLocationNode(
  { provider, providerPlaceId },
  resolveApi,
) {
  if (!provider || !providerPlaceId) {
    throw new Error('missing provider place');
  }
  const payload = await resolveApi({ provider, providerPlaceId });
  const data = payload?.data?.data ?? payload?.data ?? payload;
  const node = toActivityLocationNode(data);
  if (!node) {
    throw new Error('resolve missing locationId');
  }
  return node;
}
